import '.d{display:flex;}.ssr-plugin'
import '.a8{align-items:stretch;}.ssr-plugin'
import '.ad{justify-content:center;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.dn{background:var(--palette-white);}.ssr-plugin'
import '.ah{flex-grow:1;}.ssr-plugin'
import '.r{align-items:center;}.ssr-plugin'
import '.ai{max-width:77.5rem;}.ssr-plugin'
import '.fm{justify-content:stretch;}.ssr-plugin'
import '.bi{position:sticky;}.ssr-plugin'
import '.bj{top:0px;}.ssr-plugin'
import '.bp{z-index:10;}.ssr-plugin'
import '.fn{padding-block:1rem;}.ssr-plugin'
import '.fo{height:3rem;}.ssr-plugin'
import '.b0{justify-content:space-between;}.ssr-plugin'
import '.b2{flex-wrap:wrap;}.ssr-plugin'
import '.fp{margin-bottom:0px;}.ssr-plugin'
import '.fq{min-height:calc(100vh - 5rem);}.ssr-plugin'
import '.ex{margin-top:2rem;}.ssr-plugin'
import '.fr{padding-bottom:6rem;}.ssr-plugin'
import { ReactNode, useEffect } from 'react'
import { styled } from 'inlines'
import { Property } from 'csstype'
import useMediaQuery from '@app/util/useMediaQuery'
import { getTitleLevelStyle } from '@app/components/core/typography/styles'
import { CloseButton } from '@app/components/core/button/CloseButton'
import { pages } from '@app/util/links'
import { useLocation } from 'wouter'
import { ClientOnly, useAuthState } from '@based/sdk/react'
import { PageSeo } from '@app/components/core/seo/PageSeo'

export const PlotRegistryPageLayout = ({
  title,
  gap = '1rem',
  children,
  onClose,
}: {
  title: string
  gap?: Property.Gap<(string & {}) | 0>
  children: ReactNode
  onClose: VoidFunction
}) => {
  const isMobile = useMediaQuery()

  const authState = useAuthState()
  const [_location, navigate] = useLocation()
  const isAuthed = authState && authState.userId

  useEffect(() => {
    if (!isAuthed) {
      navigate(pages.home)
    }
  }, [isAuthed, navigate])

  return (
    <>
      <PageSeo pageTitle={title} noindex />
      <ClientOnly>
      <div className="d a8 ad e dn"
      >
        <div className="ah d r ad e"
        >
          <div className="ai d e fm bi bj bp dn"
            style={{
              width: isMobile ? '100%' : '85%',
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            <nav className="fn fo d b0 r b2"
            >
              <styled.span className="fp"
                style={{
                  ...getTitleLevelStyle(5, isMobile),}}
              >
                {title}
              </styled.span>
              <CloseButton onClick={onClose} />
            </nav>
          </div>
          <div className="fq d e a8 ex fr ai"
            style={{
              gap: gap,
              width: isMobile ? '100%' : '85%',
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            {children}
          </div>
        </div>
      </div>
      </ClientOnly>
    </>
  )
}
